import { Event } from './reducer';

interface LoadCalendarData {
    type: 'LOAD_CALENDAR_DATA';
    events: Event[];
}

export function loadCalendarData(events: Event[]): LoadCalendarData {
    return {
        type: 'LOAD_CALENDAR_DATA',
        events
    }
}

interface CalendarSelectDay {
    type: 'CALENDAR_SELECT_DAY';
    day: Date;
}

export function calendarSelectDay(day: Date): CalendarSelectDay {
    return {
        type: 'CALENDAR_SELECT_DAY',
        day
    };
}

interface CalendarSelectMonth {
    type: 'CALENDAR_SELECT_MONTH';
    month: Date;
}

export function calendarSelectMonth(month: Date): CalendarSelectMonth {
    return {
        type: 'CALENDAR_SELECT_MONTH',
        month
    };
}

export type CalendarAction
    = LoadCalendarData
    | CalendarSelectDay
    | CalendarSelectMonth;